import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logoWhite from '../assets/logos/logo-white.png';

const InitialLoader = ({ onComplete }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 100) {
                    clearInterval(timer);
                    setTimeout(onComplete, 400);
                    return 100;
                }
                return prev + 6; // Faster increment
            });
        }, 15); // Faster interval

        return () => clearInterval(timer);
    }, [onComplete]);

    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.6, ease: "easeInOut" } }}
            className="fixed inset-0 z-[100] bg-[#0d0d10] flex flex-col items-center justify-center overflow-hidden"
        >
            {/* Subtle Brand Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#3bd07a]/10 rounded-full blur-[100px] pointer-events-none animate-pulse" />

            <div className="relative z-10 flex flex-col items-center">
                {/* Logo Container - Enlarged for better visibility */}
                <motion.div
                    initial={{ scale: 0.8, opacity: 0, filter: 'blur(10px)' }}
                    animate={{ scale: 1, opacity: 1, filter: 'blur(0px)' }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="relative mb-20"
                >
                    <img
                        src={logoWhite}
                        alt="ZenCap"
                        className="h-40 w-auto object-contain"
                    />
                </motion.div>

                {/* Progress Group */}
                <div className="flex flex-col items-center gap-4">
                    <div className="w-56 h-[1.5px] bg-white/5 rounded-full overflow-hidden relative shadow-[0_0_15px_rgba(59,208,122,0.1)]">
                        <motion.div
                            className="absolute top-0 left-0 h-full bg-[#3bd07a] shadow-[0_0_10px_#3bd07a]"
                            initial={{ width: 0 }}
                            animate={{ width: `${progress}%` }}
                            transition={{ ease: "linear" }}
                        />
                    </div>

                    <div className="flex items-center gap-3">
                        <motion.span
                            className="w-1 h-1 bg-[#3bd07a] rounded-full"
                            animate={{ opacity: [0, 1, 0] }}
                            transition={{ duration: 1, repeat: Infinity }}
                        />
                        <span className="text-white/30 font-mono text-[9px] tracking-[0.4em] uppercase">
                            Securing_Access_{progress}%
                        </span>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default InitialLoader;
